import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import CloseIcon from "@mui/icons-material/Close";

import styles from "../../../SwmsMastersStyle.module.css";
import v2Styles from "../../../../v2Styles.module.css";
import layoutStyles from "../../EmergencyProceduresLayout.module.css";

export default function EditCustomEmergencyProcedureHeadingModal({
  visible,
  loading,
  initialHeading,
  onCancel,
  onSave
}) {
  const [heading, setHeading] = useState("");
  const [headingError, setHeadingError] = useState("");

  useEffect(() => {
    if (visible) {
      setHeading(initialHeading || "");
      setHeadingError("");
    }
  }, [visible, initialHeading]);

  const onSubmitSave = () => {
    const trimmedHeading = `${heading || ""}`.trim();
    if (!trimmedHeading) {
      setHeadingError("Heading is required");
      return;
    }

    setHeadingError("");
    if (typeof onSave === "function") {
      onSave(trimmedHeading);
    }
  };

  return (
    <Modal
      className="cs-modal-v2"
      centered
      footer={null}
      visible={visible}
      onCancel={onCancel}
      destroyOnClose
      maskClosable={false}
      bodyStyle={{ paddingRight: "0px", paddingLeft: "0px" }}
      closeIcon={<div className={v2Styles.ModalCloseIcon}><CloseIcon /></div>}
      width="600px"
      style={{ top: 10 }}
    >
      <div className="v2-modal-container">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className={v2Styles.ModalHeading}>Edit Section Heading</div>
              <div>
                <hr className="v3-modal-hr" />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className={styles.Label}>Heading</div>
              <input
                type="text"
                value={heading}
                onChange={(event) => {
                  setHeading(event.target.value);
                  if (headingError) {
                    setHeadingError("");
                  }
                }}
                placeholder="Heading"
                disabled={loading}
                className={styles.TextField}
                style={headingError ? { borderColor: "#f44336" } : undefined}
              />
              {headingError ? (
                <div className={layoutStyles.FieldErrorText}>{headingError}</div>
              ) : null}
            </div>
          </div>

          <div className="row pt-3">
            <div className="col-12 text-right">
              <div className={`d-flex justify-content-end align-items-center ${layoutStyles.ActionButtonsRow}`}>
                <button type="button" className={styles.OutlinedButton} onClick={onCancel} disabled={loading}>
                  Cancel
                </button>
                <button type="button" className={styles.PrimaryButton} onClick={onSubmitSave} disabled={loading}>
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

